var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aboutSkills"},[_c('p',{staticClass:"my-skills"},[_vm._v("My skills:")]),_c('div',{staticClass:"imageBackground"},[_c('img',{staticClass:"skillsImage",attrs:{"src":require("../assets/skillsChart.svg"),"alt":"my skills chart"}})])])
}]

export { render, staticRenderFns }